import Component from './tiktok_prize_table.vue'
export default Component
